import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import React, { createContext, useContext, useState } from 'react';

export const DialogContext = createContext({});

export const useDialog = () => {
  return useContext(DialogContext);
};

export const DialogProvider = ({ children }) => {
  const [state, setState] = useState({
    isOpen: false,
    title: '',
    content: '',
    action: '',
  });

  const openDialog = (title, content, action) => {
    setState({
      isOpen: true,
      title: title,
      content: content,
      action: action,
    });
  };

  const closeDialog = () => {
    const oldState = state;
    setState({
      isOpen: false,
      title: oldState.title,
      content: oldState.content,
      action: oldState.action,
    });
  };

  const contextValue = { state, openDialog, closeDialog };

  return (
    <DialogContext.Provider value={contextValue}>
      {children}
    </DialogContext.Provider>
  );
};

const DialogProviderConsumer = DialogContext.Consumer;

export const DialogCommon = () => {
  return (
    <DialogProviderConsumer>
      {({ state, closeDialog }) => (
        <Dialog
          open={state.isOpen}
          onClose={closeDialog}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
          disableBackdropClick
        >
          <DialogTitle id="alert-dialog-title">{state.title}</DialogTitle>
          <DialogContent>{state.content}</DialogContent>
          <DialogActions>{state.action}</DialogActions>
        </Dialog>
      )}
    </DialogProviderConsumer>
  );
};
